import 'alpinejs';
require('./bootstrap');
window.Vue = require('vue');
Vue.component('ajax-table', require('./components/AjaxTable.vue').default);


const app = new Vue({
    el: '#app',
});
